"use strict";
/*
 * indicative-parser
 *
 * (c) Harminder Virk <virk@adonisjs.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
*/
Object.defineProperty(exports, "__esModule", { value: true });
const getArrayType_1 = require("../utils/getArrayType");
/**
 * Create an array type schema node
 */
function array(...rules) {
    return {
        members(schema) {
            return getArrayType_1.getArrayType(schema, false, rules);
        },
    };
}
exports.array = array;
/**
 * Create an optional array type schema node
 */
array.optional = (...rules) => {
    return {
        members(schema) {
            return getArrayType_1.getArrayType(schema, true, rules);
        },
    };
};
